import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BookingService } from '../../../bookings/services/booking.service';
import { AppSettings } from '../../app.settings';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { UiService } from '../../services/ui.service';
import { MiGrid2Component } from '../mi-grid-2/mi-grid-2.component';

@Component({
  selector: 'app-merge-booking-popup',
  templateUrl: './merge-booking-popup.component.html',
  styleUrls: ['./merge-booking-popup.component.scss']
})
export class MergeBookingPopupComponent implements OnInit {
  uniqId = AppSettings.UNIQID.SHARED_MERGE_POPUP_3716;
  @Input() isVisible: boolean = false;
  @Output() onMergeComplete = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<void>();
  @ViewChild(MiGrid2Component) gridRef: MiGrid2Component;

  selectedBookingForMerge: any;
  selectedMergeBooking: any;
  selectedMergeBookings: any[] = [];
  mergeBookingsUrl: string = '';
  mergeColumns: any[] = [];
  isAllSelected: boolean = false;
  allBookingsData: any[] = [];
  recordCount = 0;
  isActionDisabled: boolean = true;
  searchPlaceHolder: any;

  constructor(
    private commonBindingDataService: CommonBindingDataService,
    private bookingService: BookingService,
    private uiService: UiService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.searchPlaceHolder = this.commonBindingDataService.getLabel(
      'label_search_by_passenger_journey_id'
    );
    this.setupMergeColumns();
    this.subscribeToMergePopup();
  }

  get mergeWithId(): string {
    const data: any = this.selectedBookingForMerge;
    if (!data) {
      return '';
    }
    const preferred = data.tripId || data.bookingCode || '';
    return this.extractPlainText(preferred);
  }

  get passengerName(): string {
    const data: any = this.selectedBookingForMerge;
    if (!data) {
      return '';
    }
    if (data.passengerName) {
      return data.passengerName;
    }
    if (data.pFirstName && data.pLastName) {
      return `${data.pFirstName} ${data.pLastName}`.trim();
    }
    if (data.pFirstName) {
      return data.pFirstName;
    }
    return '--';
  }

  get passengerType(): string {
    const data: any = this.selectedBookingForMerge;
    if (!data) {
      return '';
    }
    return data.passengerType || '';
  }

  get passengerCount(): number {
    const data: any = this.selectedBookingForMerge;
    if (!data) {
      return 0;
    }
    return data.totalNoOfPassengers || 0;
  }

  get headerText(): string {
    const bookingId = this.mergeWithId;
    const name = this.passengerName;
    const type = this.passengerType;
    const count = this.passengerCount;
    
    let header = `Merge Bookings with #${bookingId}`;
    
    if (name && name !== '--') {
      header += ` (${name}`;
      if (type) {
        header += ` | ${type}`;
      }
      header += ')';
    }
    
    if (count > 0) {
      header += ` - ${count} Pass`;
    }
    
    return header;
  }

  private extractPlainText(value: any): string {
    try {
      if (value == null) {
        return '';
      }
      if (typeof value === 'string' || typeof value === 'number') {
        return String(value).trim();
      }
      const possibleHtml = (value && typeof value === 'object' && (value as any).changingThisBreaksApplicationSecurity)
        ? (value as any).changingThisBreaksApplicationSecurity
        : String(value);
      const container = document.createElement('div');
      container.innerHTML = possibleHtml;
      const codeEl = container.querySelector('.bookingCode');
      if (codeEl && codeEl.textContent) {
        return codeEl.textContent.trim();
      }
      return (container.textContent || '').trim();
    } catch (_) {
      return '';
    }
  }

  private setupMergeColumns() {
          this.mergeColumns = [
        {
          field: 'select', header: '', sort: false, resize: true, width: 50, mergePopupCheckbox: true,class: 'merge-popup-checkbox-column',
        },
        {
            field: 'bookingCode', width: 100, header: this.commonBindingDataService.getLabel('label_booking_ID'),
            sort: false, resize: true, cellRendererHtml: (i) => (this.commonBindingDataService.getBookingTourCode(i)),
        },
        {
            field: 'pickupDateTimeStr', width: 150, header: this.commonBindingDataService.getLabel('label_pickup_at'),
            sort: false, resize: true, cellRendererHtml: (i) => (this.firstCell(i)),
        },
        {
            field: 'pFirstName', width: 200, header: this.commonBindingDataService.getLabel('grid_passenger'),
            sort: false, resize: true, cellRendererHtml: (i) => (this.getPassengerName(i)),
        },
        {
            field: 'pickupLocationName', width: 200, header: this.commonBindingDataService.getLabel('grid_pickup_drop_off'),
            sort: false, resize: true, cellRendererHtml: (i) => (this.commonBindingDataService.getPickDropLocation(i)),
        }
    ];
  }

  firstCell(params) {
    const eDiv = document.createElement('div');
    const lblStatus = `<div class="booking-grid-table">
      <div class = "pickup-time">` + params.pickupTimeStr + `</div>
      <div class = "pickup-date">` + params.pickupDateStr + `</div>
       ${params.stopOneAddress && params.stopOneLatitude && params.stopOneLongitude ? `<div class='multi-stop mt-2' title="${params.stopOneAddress}">Additional Stop</div>` : ''}
    </div>`;
    eDiv.innerHTML += lblStatus;
    return eDiv;
  }

  getPassengerName(params) {
    const passengerName = params.passengerName ? params.passengerName : '--';
    const priority = params.passengerType ? params.passengerType : '';
    const passengerCount = params.totalNoOfPassengers;
    const eDiv = document.createElement('div');
    let preparedData = '';
    let preparedData1 = '';
    if (params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.GENERAL ||
      params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.SPECIAL_EVENT ||
      params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.THIRD_PARTY) {
      preparedData1 = `<div class="booking-grid-table" title="">
        <div class="passenger-name passengerName" title="${passengerName}">${passengerName}</div>
        <div class="passengerType my-2" title="${priority}">${priority}</div>
      </div>`;
      preparedData = params.luggageTour ? `<div class = "pickup-date drop-adr pass-info passenger passengerInfo pb-2">${params.luggageTour ? (params.luggageWithTotalNoOfBagsString ? params.luggageWithTotalNoOfBagsString : '') : ''}</div>` :
        `<div title="${passengerCount} Pass ${params.totalNoOfBabyseats > 0 ? `| ${params.totalNoOfBabyseats}C` : ''} ${params.totalNoOfWheelchairs > 0 ? ` | ${params.totalNoOfWheelchairs}W` : ''} ${params.totalNoOfLuggageBagsString ? `| ${params.totalNoOfLuggageBagsString}` : ''}" class="pickup-date drop-adr pass-info passenger passengerInfo pb-2">${passengerCount} Pass <span class="child-seat">
      ${params.totalNoOfBabyseats > 0 ? `| ${params.totalNoOfBabyseats}C` : ''}
      ${params.totalNoOfWheelchairs > 0 ? ` | ${params.totalNoOfWheelchairs}W` : ''}
      ${params.totalNoOfLuggageBagsString ? `| ${params.totalNoOfLuggageBagsString}` : ''}
    </span></div>`;
    } else {
      let title = this.commonBindingDataService.getLabel('SHUTTLE');
      if (params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.VEHICLE_TRANSFER) {
        title = this.commonBindingDataService.getLabel('VEHICLE TRANSFER');
      }
      preparedData = `<div class="booking-grid-table" title="${title}">
      <div class = "passenger-name passengerName">` + title + `</div>
      </div>`;
    }
    eDiv.innerHTML += preparedData1;
    eDiv.innerHTML += preparedData
    return eDiv;
  }

  private subscribeToMergePopup() {
    this.commonBindingDataService.openMergePopupSubject.subscribe((data) => {
      if (data) {
        this.selectedBookingForMerge = data.bookingData;
        this.selectedMergeBooking = null;
        this.selectedMergeBookings = [];
        this.isAllSelected = false;
        this.isActionDisabled = true;
        this.mergeBookingsUrl = `/secure/merge-rides/eligible/bookings-list?tourId=${data.bookingData.id}&eventId=${data.bookingData.eventId}`;
        this.isVisible = true;
        this.cdr.detectChanges();
        setTimeout(() => {
          if (this.gridRef && this.mergeBookingsUrl) {
            if (typeof (this.gridRef as any).updateUrl === 'function') {
              (this.gridRef as any).updateUrl(this.mergeBookingsUrl);
            }
          }
        }, 0);
      }
    });
  }
  onMergeBookingSelect(event: any) {
    this.selectedMergeBooking = event.data;
  }

  totalCount(event: any) {
    console.log('event', event);
    this.recordCount = event ? event : 0;
  }

  onMergeCheckboxClicked(event: any) {
    const { data, isChecked } = event;
    if (isChecked) {
      this.selectedMergeBookings.push(data);
    } else {
      this.selectedMergeBookings = this.selectedMergeBookings.filter(booking => booking.id !== data.id);
    }
    this.isActionDisabled = this.selectedMergeBookings.length === 0;
    
    if (this.gridRef) {
      this.gridRef.selectedMergeBookings = [...this.selectedMergeBookings];
      this.gridRef.updateMergeHeaderCheckboxState();
      this.cdr.detectChanges();
    }
  }

  onMergeSelectAllClicked(event: any) {
    const { isChecked, data } = event;
    if (isChecked) {
      this.selectedMergeBookings = [...data];
    } else {
      this.selectedMergeBookings = [];
    }
    this.isActionDisabled = this.selectedMergeBookings.length === 0;
    
    if (this.gridRef) {
      this.gridRef.selectedMergeBookings = [...this.selectedMergeBookings];
      this.gridRef.selectedMergeCheckbox = isChecked;
    }
  }

  getSelectedMergeBookings(): any[] {
    return this.selectedMergeBookings;
  }

  onMerge() {
    if (this.selectedBookingForMerge && this.selectedMergeBookings.length > 0) {
      const mergeData = {
        requestFromTourId: this.selectedBookingForMerge.id,
        mergeRequestWithTourIdList: this.selectedMergeBookings.map(booking => booking.id)
      };
      
      this.bookingService.mergeBookings(this.selectedBookingForMerge.eventId, mergeData).subscribe(
        (result) => {
          this.uiService.showMessage(result.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
          this.onMergeComplete.emit(result);
          this.closePopup();
        },
        (error) => {
            this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
        }
      );
    }
  }

  onCancelClick() {
    this.closePopup();
  }

  private closePopup() {
    this.isVisible = false;
    this.selectedBookingForMerge = null;
    this.selectedMergeBooking = null;
    this.selectedMergeBookings = [];
    this.isAllSelected = false;
    this.isActionDisabled = true;
    this.onClose.emit();
  }
}
